import {ErrorHandler, Provider} from '@angular/core';

import {GlobalErrorHandler} from '@selpia/shared/error-handler';
import {ErrorHandlerOptions} from '../models';
import {errorHandlerOptionsToken} from './error-handler.token';


export function provideGlobalErrorHandler(options?: ErrorHandlerOptions): Provider[] {
  const defaultOptions = {
    consoleLevels: ['error', 'warn', 'info', 'debug'],
    appInsightsLevels: [],
  };

  return [
    {provide: errorHandlerOptionsToken, useValue: options || defaultOptions},
    {provide: ErrorHandler, useExisting: GlobalErrorHandler},
  ];
}
